import React from 'react';
import PropTypes from 'prop-types';
import { BodyModalReco } from "./styles";
import { TraspasoModal } from "../../../shared/components/Modal";
import { Button } from "@prima-afp/prima-ui-elements/dist/core";

const PermissionsModal = ({
  permissionsWarning,
  showPreventiveModal,
  deviceInfo,
  urlPublicZoneWithImages,
  BlockedCamera,
  askPermissions,
}) => {

  const renderMultimedia = (type) => {

    deviceInfo = deviceInfo.toUpperCase()
    if (deviceInfo.includes('ANDROID')) {
      return <img style={{marginBottom: '20px'}} className={type} src={`${urlPublicZoneWithImages}android${type === 'gifWarning' ? 'Unlock' : 'Ask'}.${type === 'gifWarning' ? 'gif':'png'}` } alt="Android guide" />;
    }
    if (deviceInfo.includes('IOS')) {
      return <img   style={{marginBottom: '20px'}} className={type} src={`${urlPublicZoneWithImages}ios${type === 'gifWarning' ? 'Unlock' : 'Ask'}.${type === 'gifWarning' ? 'gif':'png'}`} alt="iOS guide" />;
    }
    return <img  style={{marginBottom: '20px'}}  className={type} src={`${urlPublicZoneWithImages}desktop${type === 'gifWarning' ? 'Unlock' : 'Ask'}.${type === 'gifWarning' ? 'gif':'png'}`} alt="Desktop guide" />;
  };

  return (
    <>
      {permissionsWarning === false && (
        <TraspasoModal isOpen={true} btnClose={false}>
          <BodyModalReco className="modal-content-inner-skipReco modalWarning">
            <h2 className="title titleWarning">Necesitamos acceder a tu cámara</h2>
            <p className="content contentWarning">
              Puedes activar el permiso desde la configuración de tu navegador y luego volver a intentar.
            </p>
            {renderMultimedia('gifWarning')}
            <Button onClick={BlockedCamera} className="newUiBtn prevModal">
              Entendido
            </Button>
          </BodyModalReco>
        </TraspasoModal>
      )}

      {showPreventiveModal && (
        <TraspasoModal isOpen={true} btnClose={false}>
          <BodyModalReco className="modal-content-inner-skipReco">
            <h2 className="title prevDesktopT">Activa tu cámara para validar tu identidad</h2>
            <p className="content prevDesktopC">
              Selecciona <b style={{ fontWeight: '700' }}>'Permitir'</b> para poder confirmar que eres tú quien está realizando la validación.
            </p>
            {renderMultimedia('pngAsk')}
            <Button onClick={askPermissions} className="newUiBtn prevModal">
              Entendido
            </Button>
          </BodyModalReco>
        </TraspasoModal>
      )}
    </>
  );
};

PermissionsModal.propTypes = {
  permissionsWarning: PropTypes.bool,
  showPreventiveModal: PropTypes.bool,
  deviceInfo: PropTypes.arrayOf(PropTypes.string).isRequired,
  urlPublicZoneWithImages: PropTypes.string.isRequired,
  BlockedCamera: PropTypes.func.isRequired,
  askPermissions: PropTypes.func.isRequired,
};

export default PermissionsModal;
